import { changeAmount } from './';
const initProductCounter = (elementSelector) => {
    const counters = document.querySelectorAll(elementSelector);
    if (counters.length === 0)
        return false;
    counters.forEach(counter => productCounter(counter));
};
const productCounter = (counter) => {
    const plusBtn = counter.querySelector('.plus');
    const minusBtn = counter.querySelector('.minus');
    const input = counter.querySelector('input');
    if (!input || !plusBtn || !minusBtn) {
        return;
    }
    ;
    const riseHandler = (event) => raise(input);
    const lowerHandler = (event) => lower(input);
    plusBtn.addEventListener('click', riseHandler);
    minusBtn.addEventListener('click', lowerHandler);
};
const raise = (input) => {
    const max = Number(input.max);
    const value = Number(input.value);
    if (value < max) {
        input.value = (value + 1).toString();
        changeAmount(input);
    }
};
const lower = (input) => {
    const min = Number(input.min);
    const value = Number(input.value);
    if (value > min) {
        input.value = (value - 1).toString();
        changeAmount(input);
    }
};
export default initProductCounter;
